import { best_pricebreak } from "product_tabs/tab_parts/utils/part_suppliers";

const updatePartSupplier = (ps, board_qty, exact_qty, extra_parts) => {
  let order_qty = exact_qty + extra_parts;
  let bp = best_pricebreak(ps.pricebreaks, order_qty, false)

  ps.selected_pricebreak[board_qty] = bp

  return ps
}

export const changeExtraParts = (state, action_data) => {
  const { idx, board_qty, data } = action_data

  const {
    type,
    ...ext_data
  } = data

  if (type === 'multiple') return;

  const {
    extra_parts,
  } = ext_data

  if(!_.isEmpty(state.bom_line_items[idx].selected_part) &&
    !_.isEmpty(state.bom_line_items[idx].selected_part.selected_part_supplier) && 
    board_qty in state.bom_line_items[idx].selected_part.selected_part_supplier)
  {
    state.bom_line_items[idx].extra_parts[board_qty] = extra_parts
    state.bom_line_items[idx].selected_part.extra_parts[board_qty] = extra_parts
    const exact_qty = state.bom_line_items[idx].qty * board_qty
    const order_qty = exact_qty + extra_parts

    const selected_pricebreak = state.bom_line_items[idx].selected_part.selected_part_supplier[board_qty].selected_pricebreak[board_qty]
    const new_pricebreak = best_pricebreak(state.bom_line_items[idx].selected_part.selected_part_supplier[board_qty].pricebreaks, order_qty, false)
    let bp = selected_pricebreak
    let qty_to_buy = order_qty

    if(selected_pricebreak && selected_pricebreak.id !== new_pricebreak.id){
      state.bom_line_items[idx].selected_part.selected_part_supplier[board_qty].selected_pricebreak[board_qty] = _.cloneDeep(new_pricebreak)
      bp = new_pricebreak
    }
    
    if(bp && bp.qty > order_qty){
      state.bom_line_items[idx].selected_part.extra_parts[board_qty] = bp.qty - exact_qty
      state.bom_line_items[idx].extra_parts[board_qty] = bp.qty - exact_qty
      qty_to_buy = (bp.qty - exact_qty) + exact_qty
    }

    state.bom_line_items[idx].qty_to_buy[board_qty] = qty_to_buy
    state.bom_line_items[idx].price_by_qty[board_qty] = (bp.price * qty_to_buy)
  }
  
}

export const changeExtraParts2 = (state, action_data) => {
  const { extra_parts, idx, board_qty } = action_data
  state.bom_line_items[idx].extra_parts[board_qty] = extra_parts
  
  if(!isEmpty(state.bom_line_items[idx].selected_part)){
    state.bom_line_items[idx].selected_part.extra_parts[board_qty] = extra_parts
    const exact_qty = state.bom_line_items[idx].qty * board_qty

    if (!isEmpty(state.bom_line_items[idx].selected_part.selected_part_supplier)
      && board_qty in state.bom_line_items[idx].selected_part.selected_part_supplier){
      state.bom_line_items[idx].selected_part.selected_part_supplier[board_qty] = updatePartSupplier(state.bom_line_items[idx].selected_part.selected_part_supplier[board_qty], board_qty, exact_qty, extra_parts)
      const order_qty = exact_qty + extra_parts
      const bp = state.bom_line_items[idx].selected_part.selected_part_supplier[board_qty].selected_pricebreak[board_qty]
      if(bp && bp.qty > order_qty){
        state.bom_line_items[idx].selected_part.extra_parts[board_qty] = bp.qty - exact_qty
        state.bom_line_items[idx].extra_parts[board_qty] = bp.qty - exact_qty
      }
    }else{
      // Reselect part supplier for the order qty because there is not a selected_part_supplier
    }

    state.totals = calculate_totals(state.bom_line_items, state.board_qtys)
    state.report = get_bom_report(state.bom_line_items, state.board_qtys, state.selected_board_qty)
  }
}